/* ==========================================================
   NURÉVE — Voraussichtliches Lieferdatum
   Gleiche Rechnung wie im Block „Lieferdatum“ der Produktseite
   (blocks/nrv-pdp-delivery.liquid), als eigene Datei für die Startseite.

   Füllt jedes Element mit data-nrv-ship:
     data-min / data-max   Werktage frühestens / spätestens
     data-sat              "false" = Samstag zählt nicht
     data-cutoff           Bestellschluss-Stunde, 0 = aus
     data-prefix           Text vor dem Datum
   Sonntage und bundesweite Feiertage zählen nicht, Zeitzone Berlin.
   ========================================================== */
(function(){
  if (window.__nrvShip) return;
  window.__nrvShip = true;
  var DAYS = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
  var DAY = 86400000;
  var hol = {};
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function key(d){ return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function add(d, n){ return new Date(d.getTime() + n * DAY); }
  function berlinNow(){
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {};
      parts.forEach(function(p){ o[p.type] = p.value; });
      return { d: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), h: (+o.hour) % 24 };
    } catch (e) {
      var n = new Date();
      return { d: new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())), h: n.getHours() };
    }
  }
  function easter(y){
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451),
        mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, mo - 1, da));
  }
  function holidays(y){
    if (hol[y]) return hol[y];
    var e = easter(y), s = {};
    [[1,1],[5,1],[10,3],[12,25],[12,26]].forEach(function(x){ s[y + '-' + pad(x[0]) + '-' + pad(x[1])] = 1; });
    [-2, 1, 39, 50].forEach(function(off){ s[key(add(e, off))] = 1; });
    hol[y] = s;
    return s;
  }
  function isWork(d, sat){
    var wd = d.getUTCDay();
    if (wd === 0) return false;
    if (wd === 6 && !sat) return false;
    return !holidays(d.getUTCFullYear())[key(d)];
  }
  function addWork(d, n, sat){
    var c = d;
    while (n > 0) { c = add(c, 1); if (isWork(c, sat)) n--; }
    return c;
  }
  function fmt(d){ return DAYS[d.getUTCDay()] + ', ' + pad(d.getUTCDate()) + '.' + pad(d.getUTCMonth() + 1) + '.'; }
  function run(){
    document.querySelectorAll('[data-nrv-ship]').forEach(function(root){
      var line = root.querySelector('[data-nrv-ship-line]');
      if (!line) return;
      var min = parseInt(root.getAttribute('data-min'), 10) || 2;
      var max = parseInt(root.getAttribute('data-max'), 10) || min;
      if (max < min) max = min;
      var sat = root.getAttribute('data-sat') !== 'false';
      var cutoff = parseInt(root.getAttribute('data-cutoff'), 10) || 0;
      var prefix = root.getAttribute('data-prefix') || '';
      var now = berlinNow();
      var start = now.d;
      if (!isWork(start, sat) || (cutoff > 0 && now.h >= cutoff)) start = addWork(start, 1, sat);
      var a = addWork(start, min, sat);
      var b = addWork(start, max, sat);
      var dates = min === max ? fmt(a) : fmt(a) + ' – ' + fmt(b);
      line.textContent = '';
      if (prefix) line.appendChild(document.createTextNode(prefix + ' '));
      var em = document.createElement('b');
      em.textContent = dates;
      line.appendChild(em);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
